import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import { 
    Box 
} from "@mui/material";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

import "../assets/css/Product/SingleProductPage.css";
import LogoAmex from "../assets/img/logo_amex.png";
import LogoDinner from "../assets/img/logo_dinners.png";
import LogoPayu from "../assets/img/logo_payu.png";
import LogoVisa from "../assets/img/logo_visa.png";

import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CloseIcon from '@mui/icons-material/Close';

import QuantitySelector from "../components/QuantitySelector";
import { getSingleProduct } from "../services/productService";
import { CartContext } from "../context/CartContext";

import { formatNumber } from "../utils/formatNumber";

const SingleProductPage = () => {
    const { productUid } = useParams();
    const {
        addToCart,
        openCart
    } = useContext(CartContext);
    const [product, setProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [mainImage, setMainImage] = useState(null);
    const [openImagesSlider, setOpenImagesSlider] = useState(false);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const productData = await getSingleProduct(productUid);
                setProduct(productData);
                setMainImage(productData.images[0]?.url);
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        };

        fetchProduct();
    }, [productUid]);

    const handleThumbnailClick = (imageUrl) => {
        setMainImage(imageUrl);
    };

    const executeSound = () => {
        const audio = new Audio(process.env.PUBLIC_URL + '/recursos/cart_add.wav');
        audio.play();
    }

    const handleAddToCart = () => {
        const productToAdd = {
            uid: productUid,
            title: product.title,
            price: product.price,
            quantity,
            image: product.images[0]?.url,
            locations: product.locations,
            timeShipping: product.timeShipping,
            limitHourReception: product.limitHourReception,
            priceShipping: product.priceShipping,
            shippingNational: product.shippingNational,
            timeShippingNational: product.timeShippingNational,
            priceShippingNational: product.priceShippingNational,
            seller: product.userSeller,
        };
        
        executeSound();
        addToCart(productToAdd);

        setTimeout(() => {
            openCart();
        }, 500);
    };

    if (!product) {
        return <div>Loading...</div>;
    }

    return (
        <Box className="body-product-page w-100 py-5">
            <div className="single-product-page container">
                {/* Imagen principal y galería */}
                <div className="product-gallery">
                    <div className="main-image" onClick={() => setOpenImagesSlider(true)}>
                        <img src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${mainImage}`} alt={product.title} />
                    </div>
                    <div className="thumbnail-images">
                        {/* Miniaturas */}
                        {product.images.map((image, index) => (
                            <img 
                                key={index} 
                                src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${image.url}`} 
                                alt={`Miniatura ${index + 1}`} 
                                onClick={() => handleThumbnailClick(image.url)} // Manejar clic en miniatura
                            />
                        ))}
                    </div>
                </div>

                {/* Información del producto */}
                <div className="product-info">
                    <h1>{product.title}</h1>
                    <p className="d-none d-md-block m-0">{product.shortDescription}</p>
                    <p className="price mb-0">
                        ${formatNumber(quantity * product.price)}
                    </p>

                    <div className="d-flex flex-md-column flex-column-reverse gap-2 gap-md-4 w-100">
                        <div className="d-flex w-100 gap-4 align-items-end">
                            <button className="buy-button" onClick={handleAddToCart}>Comprar</button>
                            <QuantitySelector showTitle={true} onQuantityChange={setQuantity} />
                        </div>

                        <p className="delivery-info my-2">
                            Recibe este producto en <strong>{product.timeShipping} hábiles</strong> si estás en  
                            <strong className="ps-1">
                                {product.locations.map((location, index) => (
                                    <span key={index}>
                                        {location.municipality}
                                        {index < product.locations.length - 1 ? ", " : ""}
                                    </span>
                                ))}
                            </strong>.
                            {product.shippingNational && (
                                <>
                                    o en <strong>{product.timeShippingNational} hábiles</strong> a otras ciudades.
                                </>
                            )} 
                        </p>
                    </div>
                    
                    <div className="d-flex flex-md-column flex-column-reverse gap-4 w-100">
                        <div className="w-100">
                            <h2 className="title-description__product my-2">Descripción:</h2>
                            
                            <div className="product-description" dangerouslySetInnerHTML={{ __html: product.description }} />
                        </div>
                        <div className="location-info mt-4 mt-md-0">
                            <p className="d-flex align-items-center justify-content-start gap-2">
                                <LocationOnIcon /> Ubicación: 
                                <strong>
                                    {product.locations.map((location, index) => (
                                        <span key={index}>
                                            {location.municipality}
                                            {index < product.locations.length - 1 ? ", " : ""}
                                        </span>
                                    ))}
                                </strong>
                            </p>
                            <p className="d-flex align-items-center justify-content-start gap-2">
                                <LocalShippingIcon /> Valor del envío: 
                                <strong>
                                    $ {product.priceShipping ? formatNumber(product.priceShipping) : "0"}
                                </strong>
                            </p>
                        </div>

                    </div>
                    
                    <div className="w-100 d-md-block d-none">
                        <p className="mt-4 mb-2">
                            <strong>
                                Todos los métodos de pago
                            </strong>
                        </p>

                        <div className="d-flex justify-content-start">
                            <div className="payment-methods">
                                <img src={LogoPayu} alt="PayU" />
                                <img src={LogoVisa} alt="Visa" />
                                <img src={LogoDinner} alt="Dinner" />
                                <img src={LogoAmex} alt="American Express" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Box className={`modal-swiper-images ${openImagesSlider ? "active":""}`}>
                <CloseIcon className="close-icon" onClick={() => setOpenImagesSlider(false) } />
                <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
                    {product.images.map((image, index) => (
                        <SwiperSlide key={"slide-image-" + {index}}>
                            <img src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${image.url}`} alt={"image-slide-" + index} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Box>
        </Box>
    );
};

export default SingleProductPage;